import { Component, inject, OnInit, signal } from '@angular/core';
import { LayoutService, ModalService, SharedUiModule } from '@pf/shared-ui';
import { UserPositionFacade } from '@pf/platform-core/domain';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { map, switchMap } from 'rxjs';
import { Router } from '@angular/router';

@UntilDestroy()
@Component({
    selector: 'platform-active-position',
    template: `
        <pf-chip [pfColor]="activePosition().color">
            <span class="active-position-chip">
                <span>{{ activePosition().text }}</span>
                @if (hasActivePosition()) {
                    <pf-button
                        pfIcon="close"
                        error
                        buttonType="icon-rounded"
                        (click)="confirmExit()"
                        >Exit Position</pf-button
                    >
                }
            </span>
        </pf-chip>
    `,
    styles: [
        `
            :host {
                display: block;
                width: 100%;
                --pf-chip-width: 100%;

                pf-chip {
                    --pf-chip-width: 100%;
                    --pf-chip-height: 32px;
                }

                .active-position-chip {
                    padding-left: var(--pf-gap);
                    display: flex;
                    flex-direction: row;
                    justify-content: space-between;
                    align-items: center;
                    height: 100%;

                    pf-button {
                        margin-right: -10px;
                    }
                }
            }
        `,
    ],
    standalone: true,
    imports: [SharedUiModule],
})
export class ActivePositionComponent implements OnInit {
    readonly positionsFacade = inject(UserPositionFacade);
    private readonly layoutService = inject(LayoutService);
    private readonly modalService = inject(ModalService);
    private readonly router = inject(Router);

    activePosition = signal({
        text: 'No Active Position',
        color: 'processing',
    });
    hasActivePosition = signal(false);

    ngOnInit(): void {
        this.positionsFacade.active$
            .pipe(
                untilDestroyed(this),
                map(position => {
                    if (!position?.userPositionTypeId) {
                        this.activePosition.set({
                            text: 'No Active Position',
                            color: 'processing',
                        });
                        this.hasActivePosition.set(false);
                    } else {
                        this.activePosition.set({
                            text: position.userPositionTypeName || 'None',
                            color: 'success',
                        });
                        this.hasActivePosition.set(true);
                    }
                })
            )
            .subscribe();
    }

    confirmExit() {
        this.modalService.confirmAction(
            'position',
            () => {
                this.positionsFacade
                    .exitPosition$()
                    .pipe(
                        switchMap(() => {
                            this.layoutService.closeMenu();
                            return this.router.navigateByUrl('/');
                        })
                    )
                    .subscribe();
            },
            'exit',
            () => {
                // do nothing on cancel
            }
        );
    }
}
